module.exports = __webpack_public_path__ + "assets/feature-2.svg";